export const FAQ_PATH = '/faq/';

export function canonicalPath(pathname: string): string {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (['/faq', '/faqs', '/faq.html', '/faqs.html'].includes(normalized)) return FAQ_PATH;
  if (normalized === '/index.html') return '/';
  return pathname;
}

export type AppRoute = 'home' | 'faq' | 'notFound';

export function matchRoute(pathname: string): AppRoute {
  const normalized = canonicalPath(pathname);
  if (normalized === '/') return 'home';
  if (normalized === FAQ_PATH) return 'faq';
  return 'notFound';
}
